import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-[#F5E6E0] sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <span className="font-bold text-xl text-[#bc6355]">私の完全美容食</span>
        </div>
      </header>

      {/* Breadcrumb Navigation */}
      <nav className="bg-[#FFF9F7] border-b border-[#F5E6E0]">
        <div className="container mx-auto px-6 py-3">
          <ul className="flex items-center gap-2 text-sm">
            <li>
              <a 
                href="https://soyproteinranking.com/" 
                className="flex items-center gap-2 text-[#D4A59A] hover:text-[#bc6355] transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center text-[#bc6355]">
                  <i className="ri-home-4-line"></i>
                </span>
                <span>トップ</span>
              </a>
            </li>
            <li className="text-[#E8D4CF]">/</li>
            <li className="text-[#6B5750] whitespace-nowrap">私の完全美容食で内側から輝く自分へ</li>
          </ul>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Hero Section */}
        <div className="mb-12">
          <h1 className="text-3xl font-bold text-white mb-6 bg-gradient-to-r from-[#bc6355] to-[#D4A59A] px-6 py-4 rounded-lg leading-tight">
            私の完全美容食で内側から輝く自分をデザインする
          </h1>
          <p className="text-[#6B5750] leading-relaxed mb-4">
            「肌や髪のハリがなくなってきた」「プロテインの添加物が気になる」「もっと自然な素材でキレイになりたい」と悩んでいませんか？
          </p>
          <p className="text-[#6B5750] leading-relaxed">
            <span className="text-[#bc6355] font-semibold underline decoration-[#F5E6E0] decoration-4">
              私の完全美容食（わたしのかんぜんびようしょく）
            </span>
            は、
            <span className="border-b-2 border-[#bc6355] font-semibold">
              北海道産大豆100%
            </span>
            を使用し、化学添加物を一切使わず、厳選された和のスーパーフードを凝縮した贅沢な美容プロテインです。
          </p>
        </div>

        {/* Features Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            私の完全美容食の特徴や概要
          </h2>
          <p className="text-[#6B5750] leading-relaxed mb-6">
            <span className="text-[#bc6355] font-semibold">私の完全美容食</span>
            は、単なる栄養補給ではなく、女性が求める「真の美しさ」のために開発された国産品質のソイプロテインです。
          </p>
          <p className="text-[#6B5750] leading-relaxed mb-8">
            最大の特徴は、非遺伝子組み換えの
            <span className="border-b-2 border-[#bc6355] font-semibold">
              北海道産大豆「トヨミヅキ」「ユキホマレ」を丸ごと使用
            </span>
            している点です。おから成分まで含まれているため、食物繊維が豊富で、内側からのスッキリと潤いを同時にサポートします。
          </p>

          <h3 className="text-xl font-bold text-[#6B5750] mb-6">私の完全美容食がひと目でわかる!</h3>
          <div className="overflow-hidden rounded-lg border border-[#F5E6E0] shadow-sm mb-8 bg-white">
            <table className="w-full">
              <thead>
                <tr className="bg-[#FFF9F7]">
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#6B5750] border-b border-[#F5E6E0] w-1/3">
                    項目
                  </th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#6B5750] border-b border-[#F5E6E0]">
                    内容
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#F5E6E0]">
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">主原料</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">北海道産大豆「トヨミヅキ」「ユキホマレ」</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">注目美容成分</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">レモン果皮から抽出した葉酸と鉄 / 11種類の国産雑穀</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">こだわり</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">グルテンフリー / 5つの無添加（保存料・香料等）</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">栄養素</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">イソフラボン / 食物繊維 / 天然ビタミン・ミネラル</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">利便性</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">黒糖の優しい甘みでアレンジ自在</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Usage Points Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            私の完全美容食の活用ポイント
          </h2>
          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              1.「和のスーパーフード」でエイジングケア
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              豊富なイソフラボンや、善玉菌をサポートする米麹を配合。
              <strong className="text-[#bc6355]">食べる美容液</strong>
              のような感覚で、年齢に応じたケアを日々の食生活に取り入れられます。
            </p>
          </div>
          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              2.安心の「完全無添加・国産品質」
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              <strong className="text-[#bc6355]">一生付き合うカラダのため</strong>
              、合成甘味料、着色料、保存料、香料、酸化防止剤は一切使いません。素材本来の力を信じ、日本人の体に馴染む成分を追求しました。
            </p>
          </div>
          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              3.「大豆丸ごと」の驚きの腹持ち
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              大豆から抽出したタンパクだけでなく、
              <strong className="text-[#bc6355]">大豆の一粒丸ごと</strong>
              粉末に。食物繊維が豊富なので、満足感が持続し、ついつい手が伸びる間食の防止にも役立ちます。
            </p>
          </div>
        </section>

        {/* Recommended For Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            私の完全美容食はこんな人におすすめ
          </h2>
          <div className="bg-gradient-to-br from-[#FFF9F7] to-[#FFF5F2] rounded-xl p-8 border border-[#F5E6E0] shadow-sm">
            <div className="flex items-center justify-center mb-6">
              <span className="bg-[#bc6355] text-white px-4 py-2 rounded-full text-sm font-bold">
                CHECK!
              </span>
            </div>
            <ol className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  1
                </div>
                <p className="text-[#6B5750]">ただ痩せるだけでなく、肌や髪のツヤも大切にしたい</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  2
                </div>
                <p className="text-[#6B5750]">海外産よりも、産地が明確な国産素材を好む</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  3
                </div>
                <p className="text-[#6B5750]">人工甘味料のベタつく甘さが苦手で、自然な味が好き</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  4
                </div>
                <p className="text-[#6B5750]">更年期や体調の変化に向けて、質の高い大豆生活を始めたい</p>
              </li>
            </ol>
          </div>
        </section>

        {/* Summary Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            まとめ
          </h2>
          <div className="bg-gradient-to-br from-[#FFF9F7] to-[#FFF5F2] rounded-xl p-8 border border-[#F5E6E0] shadow-sm">
            <div className="flex items-center justify-center mb-6">
              <span className="bg-[#bc6355] text-white px-4 py-2 rounded-full text-sm font-bold">
                POINT
              </span>
            </div>
            <div className="space-y-4 text-[#6B5750]">
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span>
                  <strong className="text-[#bc6355]">究極の素材力:</strong> 北海道産「トヨミヅキ」「ユキホマレ」大豆を100%使用
                </span>
              </p>
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span>
                  <strong className="text-[#bc6355]">美容成分の宝庫:</strong> 国産の栄養素・米麹など和の恵みを凝縮
                </span>
              </p>
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span>
                  <strong className="text-[#bc6355]">完全無添加:</strong> 毎日安心して続けられる「優しさ」へのこだわり
                </span>
              </p>
            </div>
          </div>
          <p className="text-[#6B5750] leading-relaxed mt-8 text-center font-bold">
            「大豆の力」で、10年後も美しい自分への投資を。
          </p>

          {/* Product Image */}
          <a
            href="https://soyproteinranking.com/web/kanzen.php?p=sh"
            target="_blank"
            rel="noopener noreferrer"
            className="block mt-12 cursor-pointer hover:opacity-90 transition-opacity"
          >
            <div className="w-full h-auto">
              <img
                alt="私の完全美容食 - 北海道産大豆の美容プロテイン"
                className="w-full h-auto rounded-lg shadow-md object-cover"
                src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/3ddd47ebdc67a7a178cbb119d9790613.png"
              />
            </div>
          </a>

          {/* CTA Section */}
          <div className="mt-8 bg-[#bc6355] rounded-lg py-8 px-6 text-center">
            <p className="text-white text-sm font-medium mb-4 tracking-wide">
              SNSや雑誌で話題沸騰中！
            </p>
            <a
              href="https://soyproteinranking.com/web/kanzen.php?p=sh"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#FFF9F7] rounded-lg px-8 py-4 mb-6 cursor-pointer hover:shadow-lg transition-shadow"
            >
              <p className="text-[#8B7B74] text-xs mb-1">北海道産大豆まるごと</p>
              <p className="text-[#bc6355] text-2xl font-bold tracking-wide">私の完全美容食</p>
              <p className="text-[#bc6355] text-xs tracking-widest">beauty & wellness</p>
            </a>
            <div>
              <a
                href="https://soyproteinranking.com/web/kanzen.php?p=sh"
                target="_blank"
                rel="noopener noreferrer"
                className="relative inline-block bg-white text-[#bc6355] font-bold py-4 px-12 rounded-full cursor-pointer hover:shadow-lg transition-all overflow-hidden group whitespace-nowrap"
              >
                <span className="relative z-10">私の完全美容食の詳細を見る</span>
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}